class Translate {
	static translations = {};

	static storageName = 'translations';

	static initialized = false;

	static async init(lastUpdatedAt, forceUpdate = false) {
		let storage = JSON.parse(localStorage.getItem(Translate.storageName) ?? '{}');
		if (forceUpdate || Object.keys(storage).length === 0 || storage.last_updated_at != lastUpdatedAt) {
			await Translate.updateTranslations();
		} else {
			Translate.translations = storage.translations;
			Translate.initialized = true;
		}
		Translate.#triggerUpdateEvent();
	}

	static async updateTranslations() {
		Translate.translations = {};
		localStorage.removeItem(Translate.storageName);

		try {
			let response = await Helpers.Ajax.get(route('api.v1.translations.storage'));
			let translations = {};

			for (let index in response.translations) {
				let translation = response.translations[index];
				translation.groups = Object.keys(translation.groups);
				translations[translation.identifier] = translation;
			}
			Translate.translations = translations;
			localStorage.setItem(Translate.storageName, JSON.stringify({
				last_updated_at: response.last_updated_at,
				translations: translations
			}));
			Translate.initialized = true;
			Translate.#triggerUpdateEvent();
		} catch (error) {
			console.error("Failed to update translations", error);
		}
	}

	static #triggerUpdateEvent() {
		$(window).trigger('wwdev.translations.updated');
	}

	/**
	 * @param {string} data.identifier - The identifier (required).
	 * @param {string} data.default - The source text.
	* @param {Object} [data.replacements={}] - Key/value replacements inside the translation.
	* @param {string} [data.type="text"] - The translation type.
	* @param {string} [data.group="algemeen"] - The group/category of the translation.
	* @param {string} [data.languageCode="nl"] - Target language code.
	*/
	static async getTranslation(data) {
		if(!data.identifier) {
			console.error("Translation identifier is required.");
			return data.default || '';
		}

		if (!Translate.initialized) {
			console.warn("Translations not initialized yet. Call Translate.init() first.");
			return data.default;
		}

		data = Object.assign({
			replacements: {},
			field_type: 'text',
			group: 'algemeen',
			languageCode: 'nl'
		}, data);

		let identifier = data.identifier;
		let defaultText = data.default || data.identifier;

		let row = Translate.translations[identifier] ?? null;
		let value = null;

		if (!row) {
			value = await Translate.#createNewTranslation(defaultText, identifier, data.group, data.field_type, data.languageCode);
		} else {
			if (!row.groups.includes(data.group)) {
				await this.attachGroup(identifier, data.group);
			}

			if (row['translations'][data.group]) {
				value = row['translations'][data.group][data.languageCode] ?? null;
			} else if (row['translations']['algemeen']) {
				if (value === null) {
					value = row['translations']['algemeen'][data.languageCode] ?? null;
				}
				if (value === null) {
					value = row['translations']['algemeen']['nl'] ?? defaultText;
				}
			} else {
				value = defaultText;
			}
		}

		for (const [key, replacement] of Object.entries(data.replacements)) {
			value = value.split(`[${key}]`).join(replacement);
		}

		return value;
	}

	static attachGroup(identifier, group) {
		return Helpers.Ajax.put(route('api.v1.translations.attach-group', { identifier: identifier }), { group: group });
	}

	static async #createNewTranslation(defaultText, identifier, group, field_type, languageCode) {
		try {
			let response = await Helpers.Ajax.post(route('api.v1.translations.store'), {
				field_type: field_type,
				identifier: identifier,
				groups: {
					'algemeen': {
						[languageCode]: defaultText
					}
				}
			});
			
			Translate.translations[response.data.identifier] = response.data;

			let storage = JSON.parse(localStorage.getItem(Translate.storageName) ?? '{}');
			storage.translations = Translate.translations;
			localStorage.setItem(Translate.storageName, JSON.stringify(storage));

			this.attachGroup(response.data.identifier, group);

			return response.data.translations['algemeen'][languageCode];
		} catch (error) {
			console.error("Failed to create new translation", error);
			return defaultText;
		}
	}
}

export default Translate;